module.exports = __webpack_public_path__ + "img/device-fill.e5a57ff0.svg";